import type { SVGProps } from 'react';

type LogoProps = SVGProps<SVGSVGElement>;

interface Props {
  readonly className?: string;
  readonly descriptor?: string;
  readonly testId?: string;
}

function NxtpathLogo(props: LogoProps): JSX.Element {
  return (
    <svg viewBox="0 0 160 160" fill="none" aria-hidden="true" {...props}>
      <rect x="18" y="18" width="124" height="124" rx="10" stroke="currentColor" strokeWidth="8" />
      <path
        d="M42 104L68 56L92 104L118 56"
        stroke="currentColor"
        strokeWidth="11"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path d="M44 124H116" stroke="currentColor" strokeWidth="8" strokeLinecap="square" />
    </svg>
  );
}

/**
 * Nxtpath brand block (Field Notes, epic #950): line-drawn plate on
 * card, forest ink, serif wordmark — the masthead of the ledger. The
 * rust descriptor is one of the two sanctioned rust moments per screen
 * (DESIGN.md §1.2).
 */
export function BrandWordmark({ className, descriptor, testId }: Props): JSX.Element {
  return (
    <div
      className={['flex items-center gap-3', className ?? ''].join(' ').trim()}
      data-testid={testId}
    >
      <div className="flex h-11 w-11 items-center justify-center rounded-lg border border-line bg-card text-forest">
        <NxtpathLogo className="h-8 w-8 shrink-0" />
      </div>
      <div className="flex min-w-0 flex-col">
        <span className="block truncate font-display text-title text-ink">Nxtpath</span>
        {descriptor !== undefined && descriptor.length > 0 ? (
          <span className="block truncate font-mono text-mono-label uppercase text-rust-text">
            {descriptor}
          </span>
        ) : null}
      </div>
    </div>
  );
}
